import { useIDBKeyval } from "@vueuse/integrations/useIDBKeyval";
import type { SpecificationMetadataState, UserSpecificationState } from "types";
import type { Ref } from "vue";

const { data } = useIDBKeyval<SpecificationMetadataState[]>(
  "UserSpecifications",
  [],
  {
    shallow: false,
  }
);
export function useUsersSpecificationMetadataState(): Ref<
  SpecificationMetadataState[]
> {
  return data;
}

export function useUserSpecificationState(
  specificationId: string
): Ref<UserSpecificationState> {
  const { data } = useIDBKeyval<UserSpecificationState>(
    `UserSpecification-${specificationId}`,
    {
      inclusion: {
        userCategories: [],
        profiles: [
          {
            age: {
              min: 0,
              max: 120,
            },
            gender: "",
            linguistic: [],
            culturalBackground: [],
            educationLevel: [],
            qualifications: [],
            specificTraining: false,
          },
        ],
      },
      exclusion: {
        factors: [],
      },
    },
    {
      shallow: false,
    }
  );
  return data;
}
